import Input from '../../../components/Input';
import React from 'react';
import useFetchWaterTariffs from './useFetchWaterTariffs';

const FormWaterTariff = ({ tariffs }) => {
  const { tariff, setTariff } = useFetchWaterTariffs(tariffs);

  return (
    <Input
      classContainer={'w-full mt-4'}
      value={tariff?.consumption_tariff ?? ''}
      inputCb={(e) => {
        const val = e.target.value;
        if (val === '') {
          setTariff({ ...tariff, consumption_tariff: '' });
        } else {
          const num = Number(val);
          if (num >= 0) {
            setTariff({ ...tariff, consumption_tariff: num });
          }
        }
      }}
      label="Тариф на потребление воды, руб/м³"
      id="type"
      type="number"
      placeholder={'Укажите свой тариф подачи воды'}
    />
  );
};
export default FormWaterTariff;
